export default {
      id: "financial-patient-usage",
      viewBox: "-90 0 792 792",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#financial-patient",
      toString: function () {
        return this.url;
      }
    }